import { usePagination } from 'react-instantsearch'
import { AtIcon } from '@curran-catalog/curran-atomic-library'
import React from 'react'

export interface TmPageResultsPaginationProps {
  onPageChange: () => void
}

export const TmPageResultsPagination = ({ onPageChange }: TmPageResultsPaginationProps) => {
  const { currentRefinement, nbPages, refine } = usePagination()

  const handleOnPagination = (action: 'previous' | 'next') => {
    if (action === 'next') {
      refine(currentRefinement + 1)
    } else {
      refine(currentRefinement - 1)
    }
    if (onPageChange) {
      onPageChange()
    }
  }

  return (
    <div className="tw-flex tw-justify-center tw-items-center tw-gap-2">
      {currentRefinement !== 0 && (
        <button onClick={() => handleOnPagination('previous')} aria-label="Previous page" className="px-2 py-2">
          <AtIcon type="angle-icon" direction="left" />
        </button>
      )}
      <span>Page {currentRefinement + 1}</span>
      {currentRefinement < nbPages - 1 && (
        <button onClick={() => handleOnPagination('next')} aria-label="Next page" className="px-2 py-2">
          <AtIcon type="angle-icon" direction="right" />
        </button>
      )}
    </div>
  )
}
